import {FormPersonalInfo} from "./FormPersonalInfo";
import {FormPersonalInfoActivity} from "./FormPersonalInfoActivity";
import {FormPersonalInfoMobile} from "./FormPersonalInfoMobile";
import {FormPersonalInfoActivityMobile} from "./FormPersonalInfoActivityMobile";
import {Desktop, LandscapePhonesAndSmaller, LandscapeTablet} from "../../../utils/breakpoints";
import {AplicantOptions} from "./ApplicantOptions";
import { useIntl } from "react-intl";
import { useRequestContext } from "../../../hooks/useRequestContext";
import { useEffect, useRef } from "react";
import ClockLoader from "react-spinners/ClockLoader";
import {useState} from 'react';
import { useFormikContext } from "formik";
import { WLOCreditAPIService } from "../../../services";

interface PersonalInfoContainerProps {
    errors?: any;
    values?: any;
    setPopup: React.Dispatch<React.SetStateAction<string>>;
}

export function PersonalInfoContainer(props: PersonalInfoContainerProps) {
    const {errors, values,setPopup} = props;
    const intl = useIntl();
    const {request} = useRequestContext();
    const { setFieldValue } = useFormikContext<any>();
    const [isLoading, setIsLoading] = useState(true);
    const loadedPersonaRef = useRef('');

    useEffect(() => {
        setIsLoading(true);
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!request.personCygnus || request.searchANI) {
            return;
        }

        const persona = request.personCygnus;
        const personaKey = String(persona.Pws_i_codigo || persona.Pws_Identificacion || '');
        if (!personaKey || loadedPersonaRef.current === personaKey) {
            return;
        }
        loadedPersonaRef.current = personaKey;

        const setIf = (field: string, value: any) => {
            if (value === undefined || value === null || String(value).trim() === '') {
                return;
            }
            setFieldValue(field, value);
        };

        setIf('Pws_i_codigo', persona.Pws_i_codigo);
        setIf('Pws_Ant_labo', persona.Pws_Ant_labo);
        setIf('Pws_Apellidos1', persona.Pws_Apellidos1);
        setIf('Pws_Apellidos2', persona.Pws_Apellidos2);
        setIf('Pws_Car_emp', persona.Pws_Car_emp);
        setIf('Pws_Ciud_emp', persona.Pws_Ciud_emp);
        setIf('Pws_Ciudad_res', persona.Pws_Ciudad_res);
        setIf('Pws_Correo', persona.Pws_Correo);
        setIf('Pws_Departamento', persona.Pws_Departamento);
        setIf('Pws_Direc_emp', persona.Pws_Direc_emp);
        setIf('Pws_Direccion_res', persona.Pws_Direccion_res);
        setIf('Pws_Estado_Civil', persona.Pws_Estado_Civil);
        setIf('Pws_Estrato_per', persona.Pws_Estrato_per);
        setIf('Pws_Fec_expe', WLOCreditAPIService.fechaCygnusToFormIso(persona.Pws_Fec_expe));
        setIf('Pws_Fec_nacime', WLOCreditAPIService.fechaCygnusToFormIso(persona.Pws_Fec_nacime));
        setIf('Pws_Genero', persona.Pws_Genero);
        setIf('Pws_Identificacion', persona.Pws_Identificacion);
        setIf('Pws_Lugar_exp', persona.Pws_Lugar_exp);
        setIf('Pws_Niv_estudio', persona.Pws_Niv_estudio);
        setIf('Pws_Nom_Jefedi', persona.Pws_Nom_Jefedi);
        setIf('Pws_Nom_empre', persona.Pws_Nom_empre);
        setIf('Pws_Nombres', persona.Pws_Nombres);
        setIf('Pws_Tip_contra', persona.Pws_Tip_contra);
        setIf('Pws_Per_cargo', persona.Pws_Per_cargo);
        setIf('Pws_Telefono1', persona.Pws_Telefono1);
        setIf('Pws_Telefono2', persona.Pws_Telefono2);
        setIf('Pws_Tip_Identificacion', persona.Pws_Tip_Identificacion);
        setIf('Pws_Tip_person', persona.Pws_Tip_person);
        setIf('Pws_Tip_ocupa', persona.Pws_Tip_ocupa);
        setIf('Pws_Tip_vivienda', persona.Pws_Tip_vivienda);
        setIf('Pws_fec_ingemp', WLOCreditAPIService.fechaCygnusToFormIso(persona.Pws_fec_ingemp));
        setIf('Pws_tel_emp1', persona.Pws_tel_emp1);
        setIf('Pws_tel_emp2', persona.Pws_tel_emp2);
        setIf('Pws_Fideliza', persona.Pws_Fideliza);
    }, [request.personCygnus, request.searchANI, setFieldValue]);

    useEffect(() => {
        if (!request.direcciones) {
            return;
        }
        const direccion = [
            request.direcciones.road,
            request.direcciones.mainno,
            request.direcciones.suffix,
            request.direcciones.secondaryno,
            request.direcciones.suffix2,
            request.direcciones.complementaryno,
            request.direcciones.Complement,
            request.direcciones.complementaryno2,
            request.direcciones.Complement3,
            request.direcciones.complementaryno3,
            request.direcciones.Neighborhood,
        ].filter((parte) => parte !== undefined && parte !== null && String(parte).trim() !== '').join(' ');
        if (direccion) {
            setFieldValue('Pws_Direccion_res', direccion);
        }
    }, [request.direcciones, setFieldValue]);

    const renderTitle = () => {
        return ( 
            <>
             <ClockLoader id='spinner' color={"#01A451"} loading={isLoading} size={100}/>
                <h1 className="title-red">{intl.formatMessage({id: "form_applicant_information_title"})}</h1>
                <h1 className="subtitle-medium">{intl.formatMessage({id: "form_credit_information_subtitle"})}</h1>
                <br />
            </>
            
        )
    }

    return (
        <>
            <Desktop>
                {renderTitle()}
                <AplicantOptions values={values} errors={errors} pwsCodCredi={values.pws_cod_credi} />
                <FormPersonalInfo values={values} errors={errors} setPopup={setPopup} />
                <FormPersonalInfoActivity values={values} errors={errors}/>
            </Desktop>
            <LandscapeTablet>
            {renderTitle()}
                <AplicantOptions values={values} errors={errors} pwsCodCredi={values.pws_cod_credi}/>
                <FormPersonalInfo values={values} errors={errors} setPopup={setPopup} />
                <FormPersonalInfoActivity values={values} errors={errors} />
            </LandscapeTablet>
            <LandscapePhonesAndSmaller>
            {renderTitle()}
                <AplicantOptions values={values} errors={errors} pwsCodCredi={values.pws_cod_credi}/>
                <FormPersonalInfoMobile values={values} errors={errors} setPopup={setPopup} />
                <FormPersonalInfoActivityMobile values={values} errors={errors}/>
            </LandscapePhonesAndSmaller>
        </>
    )
}
